module.exports = __webpack_public_path__ + "media/salicylic-medium.c234bef3.mp4";